<!--资料下载-->
<template>
  <div>
    <div class="tab-box">
      <div class="tab-item-content">
        <div
          class="tab-item"
          v-for="(item,index) in tab"
          :key="index"
          :class="{active:item.status}"
          @click="selectTab(index)"
        >{{item.name}}</div>
      </div>
      <div class="add-btn-box">
        <Button type="success" @click="uploadModelShow" v-if="is_admin">新增</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoad" />

    <Modal
      v-model="upload.show"
      :loading="upload.ModelLoading"
      title="新增"
      @on-ok="SaveData"
      @on-cancel="cancel"
      width="900"
      :mask-closable="false"
    >
      <div class="form-item">
        <div class="item">
          <label class="label">文档名称</label>
          <Input v-model="formData.name" placeholder="选填（上传文件可自动填写）" class="value" />
        </div>
        <div class="item">
          <label class="label">文档版本</label>
          <Input v-model="formData.version" placeholder="必填" class="value" />
        </div>
      </div>

      <div class="form-item">
        <div class="item">
          <label class="label">文档类别</label>
          <Select v-model="typeMOdel" class="value">
            <Option v-for="(item,key) in typeArray" :value="item.value" :key="key">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="item">
          <label class="label">会员可见</label>
          <RadioGroup v-model="RadioGroupMode" class="value" style="margin-top:5px;">
            <Radio label="可见"></Radio>
            <Radio label="不可见"></Radio>
          </RadioGroup>
        </div>
      </div>

      <div class="upload-box" ref="upload" :class="{draging:draging}">
        <label
          class="ivu-btn ivu-btn-primary"
          @click="InputClick"
          v-if="!upload.uploadStatus"
        >{{formData.link ? '文件已上传，如需重新上传请点击或拖拽文件上传' : '点击或拖拽文件上传'}}</label>
        <label class="ivu-btn ivu-btn-primary" v-if="upload.uploadStatus">正在上传，请等待</label>
        <input
          type="file"
          id="uploads"
          multiple="multiple"
          style="position: absolute; clip: rect(0px, 0px, 0px, 0px);"
          @change="uploadChange"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// const OSS = require("ali-oss");
import OSS from 'ali-oss'
import config from '../../../config'
export default {
  data () {
    return {
      is_admin: false,
      tab: [
        {
          name: '终端软件',
          status: 1
        },
        {
          name: '打印驱动',
          status: 0
        },
        {
          name: '手册',
          status: 0
        },
        {
          name: '宣传资料',
          status: 0
        },
        {
          name: '视频资料',
          status: 0
        }
      ],
      selectIndex: 0,
      columns: [
        {
          title: '编号',
          key: 'id'
        },
        { title: '文件名称', width: 280, key: 'name' },
        { title: '版本', key: 'version', width: 200 },
        // {
        //   title: "更新时间",
        //   key: "create_time",
        //   render: (h, data) => {
        //     return h("span", this.$moment(new Date(data.row.create_time)));
        //   }
        // },
        {
          title: '普通用户可见',
          key: 'is_user',
          render: (h, data) => {
            switch (data.row.is_user) {
              case 0:
                return h('span', {}, '不可见')
                break
              case 1:
                return h('span', {}, '可见')
                break
            }
          }
        },
        {
          title: '操作',
          key: 'is_user',
          render: (h, data) => {
            console.log(this.is_admin)
            let btnArray = [
              h(
                'Button',
                {
                  props: { type: 'success', size: 'small' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      window.open(data.row.link)
                    }
                  }
                },
                '下载'
              ),
              h(
                'Button',
                {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      delete data.row._index
                      delete data.row._rowKey
                      delete data.row.create_time
                      this.formData = data.row
                      this.upload.show = true
                    }
                  }
                },
                '修改'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {},
                  on: {
                    click: () => {
                      this.deleteData({
                        id: data.row.id
                      })
                    }
                  }
                },
                '删除'
              )
            ]
            if (!this.is_admin) btnArray.splice(1, 2)
            return btnArray
          }
        }
      ],
      upload: {
        show: false,
        ModelLoading: false,
        uploadStatus: false
      },
      data: [],
      tableLoad: false,
      formData: {
        name: '',
        id: '',
        link: '',
        is_user: '',
        is_del: 0,
        version: '',
        type: ''
      },
      typeArray: [
        {
          value: 0,
          label: '终端软件'
        },
        {
          value: 1,
          label: '打印驱动'
        },
        {
          value: 2,
          label: '手册'
        },
        {
          value: 3,
          label: '宣传资料'
        },
        {
          value: 4,
          label: '视频资料'
        }
      ],
      typeMOdel: 0,
      RadioGroupMode: '可见',
      draging: false
    }
  },
  methods: {
    ...mapActions([
      'GetDownInformation',
      'SaveDownInformation',
      'DeleteDownInformation'
    ]),
    uploadModelShow () {
      this.upload.show = true
    },
    selectTab (index) {
      this.selectIndex = index
      this.typeMOdel = index
      this.tab.map((item, key) => {
        if (key === index) item.status = 1
        else item.status = 0
      })
      this.data = []
      this.getData()
    },
    getData () {
      this.tableLoad = true
      this.GetDownInformation({ type: this.selectIndex }).then(res => {
        this.data = res
        this.tableLoad = false
      })
    },
    SaveData () {
      let data = this.formData
      data.type = this.typeMOdel
      console.log(1212121, data)
      if (!data.name) {
        this.$Message.error('请填写文档名称')
        return false
      }
      if (!data.version) {
        this.$Message.error('请填写文档版本')
        return false
      }

      if (!data.link) {
        this.$Message.error('请上传文件')
        return false
      }
      data.is_user = this.RadioGroupMode === '可见' ? 1 : 0

      this.SaveDownInformation(data).then(res => {
        this.getData()
        this.uploadStatus = false
        this.$Message.success(data.id ? '修改成功' : '新增成功')
        this.upload.ModelLoading = false
        this.upload.show = false
        this.formData = {
          name: '',
          id: '',
          link: '',
          is_user: '',
          is_del: 0,
          version: '',
          type: ''
        }
      })
    },
    cancel () {},
    deleteData (data) {
      this.DeleteDownInformation(data).then(res => {
        this.getData()
        this.$Message.success('删除成功')
      })
    },
    InputClick () {
      document.getElementById('uploads').click()
    },
    bindRef () {
      // 绑定拖拽文件
      this.$refs.upload.addEventListener(
        'dragover',
        e => {
          e.preventDefault()
          if (!this.draging) {
            this.draging = true
          }
        },
        false
      )
      this.$refs.upload.addEventListener(
        'dragleave',
        e => {
          e.preventDefault()
          if (this.draging) {
            this.draging = false
          }
        },
        false
      )
      // 拖拽结束时触发
      this.$refs.upload.addEventListener(
        'drop',
        e => {
          e.preventDefault()
          this.draging = false
          let files = e.dataTransfer.files
          this.UploadFile(files[0])
        },
        false
      )
    },
    UploadFile (file) {
      this.upload.uploadStatus = true
      const OssClient = new OSS({
        region: config.oss.region,
        endpoint: config.oss.region,
        accessKeyId: config.oss.accessKeyId,
        accessKeySecret: config.oss.secretAccessKey,
        bucket: config.oss.bucket
      })
      OssClient.put('down/' + file.name, file)
        .then(res => {
          if (!this.formData.name) this.formData.name = file.name
          this.formData.link = res.url
          this.upload.uploadStatus = false
          this.$Message.success('上传成功')
        })
        .catch(err => {
          console.log(err)
          this.$Message.success('error')
        })
    },
    uploadChange () {
      let file = document.getElementById('uploads').files[0]
      this.UploadFile(file)
    }
  },
  mounted () {
    this.getData()
    this.bindRef()
    console.log(this.access)
    if (this.access[0] == 0) {
      // 最高权限管理员
      this.is_admin = true
    }
  },
  computed: mapGetters({
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
